<form [formGroup]="rootForm" *ngIf="! currentControl.disabled">
  <div class="form-check form-row mx-1">
    <input *ngIf="! afficherEnLectureSeule" type="checkbox" [readOnly]="afficherEnLectureSeule"
    [formControlName]="label" class="form-check-input" [id]="idHtml">
    <mat-icon *ngIf="afficherEnLectureSeule && ! currentControl.value">crop_square</mat-icon>
    <mat-icon *ngIf="afficherEnLectureSeule && currentControl.value">done</mat-icon>
    <label class="form-check-label" [for]="idHtml">{{libelle$ | async}}</label>
    <bis-affiche-erreurs *ngIf="erreursAffichable()" class="col-12" [erreurs]="rootForm.get(label).errors">
    </bis-affiche-erreurs>
  </div>
</form>
